import { Color } from "../color";

export const button = {
	baseStyle: {
		color: 'cartridge.blue',
		fontWeight: 'bold',
		bg: Color.HASHUP,
		cursor: 'pointer',
		opacity: '1',
		borderRadius: '8px',
		border: '2px solid',
		borderColor: 'cartridge.red',
		padding: '14px 40px',
		position: 'relative',
		textTransform: 'uppercase',
		_hover: {
			bg: Color.HASHUP + 'dd'
		}
	},
	sizes: {
		md: {
			fontSize: '14px',
			px: '32px ',
		},
	},
	variants: {
		base: {
			color: 'white',
		},
		sharp: {
			color: 'white',
			borderRadius: '3px',
		},
		ghost: {
			color: 'white',
			backgroundColor: 'transparent',
			_hover: {
				bg: 'cartridge.red',
			},
		},
		circle: {
			borderRadius: '50%',
			px: '0',
			w: '46px',
			h: '46px',
			bg: 'transparent',
			_hover: {
				bg: 'cartridge.red',
			},
		},
	},
	defaultProps: {
		variant: 'base',
	},
};
